import { RequestStatus } from 'clickNgo/configs/service/common'
import { LandingCategory } from 'partner360/models/landing/LandingCategory'
import { LandingOffering } from 'partner360/models/landing/LandingOffering'
import { LandingStatus } from 'partner360/models/landing/LandingStatus'

import { ILandingState } from './models/state'

export const initialState: ILandingState = {
  partners: [],
  plannings: [],
  processedPlannings: [],

  selectedPlanning: {
    PlanningId: '',
    IsActive: 0,
    AllCategories: [],
    FYear: 0,
    FQuarter: 0,
    AllStatuses: '',
    Deadlines: [],
  },
  selectedOffering: LandingOffering.Total,
  selectedCategory: LandingCategory.MyPartners,
  selectedStatus: LandingStatus.NotCompleted,

  fetchStatus: RequestStatus.NONE,

  fetchPlanInitStatus: RequestStatus.NONE,
  searchValue: '',
  isSearchMode: false,
  foundProcess: null,
  partnerSearchStatus: RequestStatus.NONE,
  isNotSearchData: false,
  foundPartners: [],

  countOfPartnersForInitPlans: 0,
  countOfPartnersWithInitializedPlans: 0,
  isNoData: false,

  refreshLandingStatus: RequestStatus.NONE,
}
